<script setup lang="ts">
import { BRAND_VIEWS, brandView } from '../brand'
import { t } from '../i18n'

/**
 * Global · Tothor · 1cards (2026-10-14). Three choices, so a segmented control
 * rather than a toggle; it sits beside the language switch and shares its look.
 */
</script>

<template>
  <div
    class="inline-flex items-center rounded-full border border-line bg-raised p-0.5 text-[12px] font-medium"
    role="radiogroup"
    :aria-label="t('brand.view')"
  >
    <button
      v-for="b in BRAND_VIEWS"
      :key="b.code"
      type="button"
      role="radio"
      :aria-checked="brandView === b.code"
      class="rounded-full px-2.5 py-0.5 transition-colors"
      :class="brandView === b.code ? 'bg-brand text-white' : 'text-fg-dim hover:text-fg'"
      @click="brandView = b.code"
    >
      {{ t(b.label) }}
    </button>
  </div>
</template>
